<template>
  <ResponsiveModal
    ref="modal"
    :variant="variant"
    :title="title"
    :description="description"
    :withClear="false"
    :withSearch="withSearch"
    :confirmLabel="$t('components.buttons.save')"
    :showCancel="!maxSmall"
    :disableConfirm="!selection.children"
    @confirm="emit('update', space)"
  >
    <slot />
    <template #content>
      <LinkToSelector
        v-model="selection"
        :query="modal?.query"
        :buildingId="buildingId"
        :buildings="buildings"
        :multiple="multiple"
        :allowedTypes="['space']"
        class="relative bg-primary"
        @clear:search="modal?.clearQuery()"
      />
    </template>
  </ResponsiveModal>
</template>

<script setup>
import { ref, computed } from "vue";
import { flatMapDeep } from "lodash";
import { LinkToSelector } from "@/SharedComponents/LinkToSelector";
import { ResponsiveModal } from "@/SharedComponents/ResponsiveModal";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { useSites } from "@/Composables/useSites";

// Define Emits
const emit = defineEmits(["update"]);

// Breakpoints
const { maxSmall } = useBreakpoints();

// Sites
const { isLoading, data } = useSites();

// Define Props
const props = defineProps({
  variant: { type: String, default: "property" },
  title: { type: String, required: true },
  description: { type: String, required: false },
  withSearch: { type: Boolean, default: false },
  initialState: { type: Object, default: () => ({}) },
  buildingId: { type: String, required: false },
  buildingIds: { type: Array, required: false },
});

// Refs
const selection = ref(
  props.initialState
    ? { ...props.initialState }
    : { buildings: [props.buildingId], children: [] }
);
const modal = ref(null);

// Computed Props
const buildings = computed(() => {
  if (isLoading.value) {
    return [];
  }
  return data.value;
});

const space = computed(() =>
  flatMapDeep(
    buildings.value.find((building) => building.id === props.buildingId)
      .children
  ).find((item) => item.id === selection.value?.children?.[0])
);
</script>
